export default {
  phoneNumber: {
    'validation.required': 'Oops! You forgot to enter your mobile phone number',
    'validation.not-valid-format': 'Oops! Your phone number needs to begin with 07 and needs to be 11 digits'
  }
}
